<template>
  <div class="product-type" :class="{ 'product-selection-mobile': isMobile }">
    <div class="product-type-title">
      <span class="icon">*</span>
      请选择您所在的城市
    </div>
    <div class="product-type-content">
        <el-select
        v-model="cityName"
        filterable
        placeholder="请选择城市"
        @change="cityChange"
        class="city-select"
      >
        <el-option
          v-for="item in cityDataList"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        ></el-option>
      </el-select>
    </div>
    <div class="product-type-title">
      <span class="icon">*</span>
      请根据以下提示信息选择符合您情况的问题类型
    </div>
    <div class="product-type-content">
      <el-collapse v-model="activeNames">
        <div v-for="item in list" :key="item.id">
          <el-collapse-item v-if="item.childList.length" :title="item.title" name="1">
            <el-radio-group v-model="questionType">
              <el-radio
                v-for="value in item.childList"
                :key="value.questionId"
                :label="value.questionId"
                @change="change(value)"
              >
                <span
                  class="success"
                  :style="{
                    background:
                      value.questionId === questionType
                        ? `center center / 70% 50% no-repeat url(${'/dsr/success.png'}) #0076FC`
                        : '',
                    borderColor: value.id === questionType ? '#0076FC' : '',
                  }"
                ></span>
                {{ value.title }}
              </el-radio>
            </el-radio-group>
          </el-collapse-item>
          <div v-else>
            <el-radio-group class="addition" v-model="questionType">
              <el-radio :label="item.questionId" @change="change(item)">
                <span
                  class="success"
                  :style="{
                    background:
                      item.questionId === questionType
                        ? `center center / 60% 50% no-repeat url(${'/dsr/success.png'}) #0076FC`
                        : '',
                    borderColor: item.id === questionType ? '#0076FC' : '',
                  }"
                ></span>
                {{ item.title }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-collapse>
      <div class="product-type-title"><span class="icon">*</span>请详细描述您的问题</div>
      <el-input
        type="textarea"
        v-model="desc"
        placeholder="请输入不少于20个字的问题表述，以便为您提供更好的服务"
        @blur="textBlur"
        @focus="() => (tag = false)"
      ></el-input>
      <div class="tips" :style="{ color: tag ? 'red' : 'transparent' }">
        请输入至少20个字！
      </div>
      <div class="attachment-upload">
        <div class="attachment-upload-tips">
          上传附件（可用来说明您问题的截图，建议图片格式为：JPEG/PNG/JPG，最多可上传5张,照片最大支持3M）
        </div>
        <el-upload
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :limit="5"
          :file-list="fileList"
          :before-upload="beforeAvatarUpload"
          action=""
          :http-request="uploadFile"
          :on-exceed="exceed"
        >
          <i class="el-icon-plus"><span>上传照片</span></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
      <el-button type="primary" @click="nextStep">下一步</el-button>
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
import cosClient from "../../plugin/cosClient";
export default {
  name: "ProblemType",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeNames: ["1"],
      list: [],
      dialogImageUrl: "",
      dialogVisible: false,
      questionType: 0,
      desc: "",
      urlList: [],
      fileList: [],
      tag: false,
      cityName: "",
      cityList: [],
      cityDataList: [],
      allCityData: [], // 存储所有城市数据
    };
  },
  methods: {
    nextStep() {
      if (!this.cityName) {
        this.$message({
          type: "warning",
          message: "请选择您所在的城市",
        });
        return;
      }
      if (
        this.radio !== 0 &&
        this.desc &&
        this.desc.length >= 20 &&
        this.desc.length <= 255 &&
        this.questionType !== 0
      ) {
        // 确保保存城市相关信息
        const selectedCity = this.cityDataList.find(item => item.name === this.cityName);
        if (selectedCity) {
          this.$store.commit("app/CHANGE_CITYCODE", selectedCity.cityCode);
          this.$store.commit("app/CHANGE_CITYNAME", selectedCity.name);
        }
        this.$store.commit("app/CHANGE_STEP", 3);
        this.$store.commit("app/CHANGE_TAG", 3);
        this.$store.commit("app/CHANGE_QUESTION", this.questionType);
        this.$store.commit("app/CHANGE_DESC", this.desc);
        this.$store.commit("app/CHANGE_URL", this.dialogImageUrl);
        this.$router.push("/dsr/capital-retention");
      } else if (this.questionType === 0) {
        this.$message({
          type: "warning",
          message: "请选择问题类型",
        });
      } else if (this.desc.length < 20 || this.desc.length > 255) {
        this.$message({
          type: "warning",
          message: "描述信息不符合要求",
        });
      } else {
        this.$message({
          type: "warning",
          message: "请将信息填写完整",
        });
      }
    },
    cityChange(value) {
      const selectedCity = this.cityDataList.find(item => item.name === value);
      if (selectedCity) {
        this.$store.commit("app/CHANGE_CITYCODE", selectedCity.cityCode);
        this.$store.commit("app/CHANGE_CITYNAME", selectedCity.name);
      }
    },
    remoteSearchCity(query) {
      // 前端模糊搜索
      if (query && query.trim() !== '') {
        const searchQuery = query.trim().toLowerCase();
        this.cityDataList = this.allCityData.filter(item => 
          item.name.toLowerCase().includes(searchQuery)
        );
        this.cityList = this.cityDataList.map(item => item.name);
      } else {
        // 如果查询为空，显示所有城市
        this.cityDataList = this.allCityData;
        this.cityList = this.allCityData.map(item => item.name);
      }
    },
    // 加载所有城市数据
    loadAllCities() {
      api.getCityList().then((res) => {
        if (res && res.code === 0 && res.data) {
          this.allCityData = res.data;
          this.cityDataList = res.data;
          this.cityList = res.data.map(item => item.name);
        }
      }).catch(err => {
        console.error('加载城市列表失败:', err);
      });
    },
    handleRemove(file) {
      this.urlList = this.urlList.filter((item) => {
        return item.split("_")[2] !== decodeURIComponent(file.name);
      });
      this.dialogImageUrl = this.urlList.join("@");
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadFile(data) {
      let formData = new FormData();
      formData.append("file", data.file);
      api.uploadFileDsr(formData).then((res) => {
        if (res.code === 0) {
          let dataObj = {
            tmpSecretId: res.data.tmpSecretId,
            tmpSecretKey: res.data.tmpSecretKey,
            sessionToken: res.data.sessionToken,
          };
          const client = cosClient(dataObj);
          const randomName = res.data;
          this.urlList.push(randomName);
          client.putObject(
            {
              Bucket: res.data.bucket,
              Region: res.data.region,
              Key: randomName,
              Body: data.file,
              onProgress() {},
            },
            (err, data) => {
              this.dialogImageUrl = this.urlList.join("@");
            }
          );
        }
      });
      // api.uploadFileConfig().then((res) => {
      //   if (res.code === 0) {
      //     let dataObj = {
      //       tmpSecretId: res.data.tmpSecretId,
      //       tmpSecretKey: res.data.tmpSecretKey,
      //       sessionToken: res.data.sessionToken,
      //     };
      //     const client = cosClient(dataObj);
      //     const randomName = `/dsr/package/${this.random_string(
      //       6
      //     )}_${new Date().getTime()}_${data.file.name}`;
      //     this.urlList.push(randomName);
      //     client.putObject(
      //       {
      //         Bucket: res.data.bucket,
      //         Region: res.data.region,
      //         Key: randomName,
      //         Body: data.file,
      //         onProgress() {},
      //       },
      //       (err, data) => {
      //         this.dialogImageUrl = this.urlList.join("@");
      //       }
      //     );
      //   }
      // });
    },
    beforeAvatarUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toUpperCase();
      const extension = testmsg === "PNG";
      const extension2 = testmsg === "JPG";
      const extension3 = testmsg === "JPEG";
      const isLt2M = file.size / 1024 / 1024 <= 3;
      if (!extension && !extension2 && !extension3) {
        this.$message({
          message: "上传的图片格式只能是 png、jpg、jpeg格式!",
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传的图片最大不能超过3M!请重新选择!",
          type: "warning",
        });
        return false;
      }
    },
    random_string(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678";
      let maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    radioChange(item) {
      this.questionType = item.id;
    },
    textBlur() {
      if (this.desc.length < 20 || this.desc.length >= 255) {
        this.tag = true;
      }
    },
    exceed() {
      this.$message({
        type: "warning",
        message: "最多上传5个附件",
      });
    },
    success() {
      this.$message({
        type: "success",
        message: "附件上传成功",
      });
    },
    change(value) {
      this.$store.commit("app/CHANGE_QUESTIONNAME", value.title);
    },
  },
  computed: {
    step() {
      return this.$store.state.app.step;
    },
  },
  async created() {
    this.readDictByKey("privacyAdminGuide", (res) => {
      this.list = res.list.dsrConfig.questionList;
    });
    // 加载所有城市数据
    this.loadAllCities();
  },
  async mounted() {
    if (this.step === 1) {
      this.$router.push("/dsr/product");
    }
    this.questionType = this.$store.state.app.questionType;
    this.desc = this.$store.state.app.desc;
    this.cityName = this.$store.state.app.cityName;
    this.urlList = this.$store.state.app.questionImgUrl.split("@");
    if (this.$store.state.app.questionImgUrl) {
      let arr = this.$store.state.app.questionImgUrl.split("@");
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]) {
          api.downloadLink({ fileKey: arr[i] }).then((res) => {
            this.dialogImageUrl += `@${
              res.data.split("privacy-backend/")[1].split("?")[0]
            }`;
            this.fileList.push({
              name: res.data.split("privacy-backend/")[1].split("?")[0],
              url: res.data,
            });
          });
        }
      }
    }
  },
};
</script>
<style lang="scss">
.product-type {
  font-size: calc($multiple * 0.215px * 80);
  .icon {
    color: red;
    margin-right: calc($multiple * 0.1px * 80);
  }
  .product-type-content {
    .city-select {
      width: 100%;
      margin-bottom: calc($multiple * 0.4px * 80);
      .el-input__inner {
        height: calc($multiple * 0.68px * 80);
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 3px;
        font-size: calc($multiple * 0.215px * 80);
      }
    }
    .el-collapse {
      border: 0;
      margin-bottom: 20px;
      .el-collapse-item__header,
      .el-collapse-item__wrap {
        border: 0;
        font-size: calc($multiple * 0.215px * 80);
      }
      .el-collapse-item__header {
        margin: calc($multiple * 0.215px * 80) 0 calc($multiple * 0.08px * 80);
        height: calc($multiple * 0.33px * 80);
        color: #000000;
      }
      .el-collapse-item__content {
        padding-bottom: calc($multiple * 0.1px * 80);
        .el-radio-group {
          padding-left: calc($multiple * 0.4px * 80);
        }
      }
      .el-radio-group {
        display: flex;
        flex-direction: column;
        .el-radio__label {
          color: rgba(0, 0, 0, 0.65);
          font-size: calc($multiple * 0.215px * 80);
          height: calc($multiple * 0.33px * 80);
          position: relative;
          .success {
            display: inline-block;
            vertical-align: bottom;
            width: calc($multiple * 0.25px * 80);
            height: calc($multiple * 0.25px * 80);
            border-radius: calc($multiple * 0.125px * 80);
            border: 1px solid #ccc;
          }
        }
        .el-radio.is-checked {
          .el-icon-success::before {
            color: #2a74f3;
            border: 0 !important;
          }
        }
        .el-radio {
          margin: calc($multiple * 0.15px * 80) 0;
          .el-icon-success {
            border: 1px solid #ccc;
            width: calc($multiple * 0.23px * 80);
            height: calc($multiple * 0.23px * 80);
            border-radius: calc($multiple * 0.15px * 80);
            color: transparent;
          }
        }
      }
      .addition {
        .el-radio__label {
          color: #000000;
        }
      }
    }
    .el-radio__inner {
      width: calc($multiple * 0.3px * 80);
      height: calc($multiple * 0.3px * 80);
      display: none;
    }
    .el-textarea__inner {
      height: calc($multiple * 2px * 80);
      border: 1px solid rgba(0, 0, 0, 0.15);
      padding-left: calc($multiple * 0.18px * 80);
      padding-top: calc($multiple * 0.18px * 80);
      font-size: calc($multiple * 0.215px * 80);
      margin-top: calc($multiple * 0.108px * 80);
    }
    .el-collapse-item__header {
      padding-left: calc($multiple * 0.41px * 80);
      position: relative;
      .el-collapse-item__arrow.el-icon-arrow-right {
        position: absolute;
        left: calc($multiple * 0.125px * 80);
      }
    }
    .el-upload--picture-card {
      width: calc($multiple * 1.23px * 80);
      height: calc($multiple * 1.23px * 80);
      position: relative;
      background: rgba(0, 0, 0, 0.04);
      .el-icon-plus {
        position: absolute;
        top: calc($multiple * 0.3px * 80);
        left: calc($multiple * 0.5px * 80);
        font-size: calc($multiple * 0.2px * 80);
        span {
          position: absolute;
          bottom: calc($multiple * -0.4px * 80);
          left: calc($multiple * -0.5px * 80);
          width: calc($multiple * 1.23px * 80);
          font-size: calc($multiple * 0.169px * 80);
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
    .el-button {
      width: calc($multiple * 1.96px * 80);
      height: calc($multiple * 0.67px * 80);
      border-radius: calc($multiple * 0.1px * 80) !important;
      margin-left: calc($multiple * 3.5px * 80);
      text-align: center;
      padding: 0 !important;
      span {
        font-size: calc($multiple * 0.22px * 80);
      }
    }
    .attachment-upload {
      margin-bottom: calc($multiple * 45px);
      .el-upload-list__item-actions {
        width: calc($multiple * 1.23px * 80);
        height: calc($multiple * 1.23px * 80);
      }
      .el-upload-list__item {
        width: calc($multiple * 1.23px * 80);
        height: calc($multiple * 1.23px * 80);
      }
      .attachment-upload-tips {
        margin-bottom: calc($multiple * 20px);
      }
    }
    .tips {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
}
.product-selection-mobile {
  font-size: 0.72rem;
  .icon {
    color: red;
    margin-right: 0.1rem;
  }
  .product-type-title {
    padding: 0.72rem 0;
  }
  .product-type-content {
    .city-select {
      width: 100%;
      margin-bottom: 0.72rem;
      .el-input__inner {
        height: 2.25rem;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0.16rem;
        font-size: 0.72rem;
      }
    }
    .el-collapse {
      border: 0;
      padding-bottom: 0.1rem;
      margin-bottom: 0;
      .el-collapse-item__header,
      .el-collapse-item__wrap {
        font-size: 0.72rem;
        border: 0;
      }
      .el-collapse-item__content {
        padding-bottom: 0.1rem;
        .el-radio-group {
          padding-left: 0.4rem;
        }
      }
      .el-collapse-item__header {
        /* margin: 0.215rem 0.5rem 0.413rem; */
        height: 1.12rem;
        /* height: 0.33rem; */
        .el-collapse-item__arrow.el-icon-arrow-right {
          left: -0.5rem;
        }
      }
      .el-radio-group {
        .el-radio__label {
          font-size: 0.72rem;
          .success {
            display: inline-block;
            vertical-align: bottom;
            width: 0.81rem;
            height: 0.81rem;
            border-radius: 0.41rem;
            border: 1px solid #ccc;
          }
        }
        .el-radio {
          margin: 0.257rem 0;
          height: 1.12rem;
          .el-icon-success {
            width: 0.81rem;
            height: 0.81rem;
            border-radius: 0.41rem;
          }
        }
      }
      .addition {
        .el-radio__label {
          padding: 0;
          color: #000000;
        }
      }
    }
    .attachment-upload {
      span {
        font-size: 0.613rem;
      }
    }
    .el-radio__inner {
      width: 0.3rem;
      height: 0.3rem;
    }
    .el-textarea__inner {
      height: 6.67rem;
      width: 100%;
      padding: 0.56rem 0 0 0.66rem;
      font-size: 0.72rem;
      margin-bottom: 0;
    }
    .el-collapse-item__header {
      margin: 0.257rem 0.5rem !important;
      padding-left: 0.5rem;
      position: relative;
      .el-collapse-item__arrow.el-icon-arrow-right {
        position: absolute;
        left: 0rem;
      }
    }
    .el-upload--picture-card {
      width: 4.1rem;
      height: 4.1rem;
      .el-icon-plus {
        font-size: 0.94rem;
        top: 1.08rem;
        left: 1.56rem;
        span {
          top: 1.6rem;
          left: -1rem;
          width: 3rem;
          font-size: 0.54rem;
        }
      }
    }
    .el-button {
      margin-top: 1.84rem;
      margin-bottom: 1.12rem;
      width: 6.56rem;
      height: 2.25rem;
      border-radius: 0.16rem !important;
      margin-left: 5.5rem;
      span {
        font-size: 0.72rem;
      }
    }
    .attachment-upload {
      margin-bottom: 0.7rem;
      .el-upload-list__item-actions {
        width: 4.1rem;
        height: 4.1rem;
      }
      .el-upload-list__item {
        width: 4.1rem;
        height: 4.1rem;
      }
      .attachment-upload-tips {
        margin-bottom: 1rem;
      }
    }
    .tips {
      font-size: 0.72rem;
      margin-bottom: 0.5rem;
    }
  }
}
</style>
